<template>
  <div id="testPaperIndex">
    <div class="title">
      <h3>模块管理</h3>
      <el-button @click="handleAddPager()" size="small" type="primary">新增评审细则</el-button>
    </div>
    <div class="testPapes">
      <h4>默认模块</h4>
      <div class="boxDiv">
        <div class="left">
          <div class="row top">
            <img src="../../assets/img/iconPark.png" alt="" />
            <h4>默认模块A</h4>
          </div>
          <div class="row bottom">
            <p>年度评审通用模块 - 适用于所有企业 - 所有企业均参与</p>
          </div>
        </div>
      </div>
      <h4>定制模块</h4>
      <template v-if="testPapeList && testPapeList.length">
        <!-- pc端 -->
        <div class="boxDiv pcBox" v-for="(item, index) in testPapeList" :key="`${index}a`">
          <div class="left">
            <div class="row top">
              <img src="../../assets/img/iconPark.png" alt="" />
              <h4>{{ item.name }}</h4>
              <p class="Use">使用企业数量：{{ item.userCount }} 家</p>
            </div>
            <div class="row bottom">
              <p>日常评审</p>
              <p class="Use">创建日期：{{ moment(item.createTime).format('YYYY.MM.DD') }}</p>
            </div>
          </div>
          <div class="right">
            <span>详情</span>
            <span @click="handleAddPager(item)">编辑</span>
            <span @click="httpDeleteIndustry(item.id)">删除</span>
          </div>
        </div>
        <!-- 移动端 -->
        <div class="boxDiv ipone" v-for="(item, index) in testPapeList" :key="`${index}d`">
          <div class="left">
            <div class="row top">
              <img src="../../assets/img/iconPark.png" alt="" />
              <h4>{{ item.name }}</h4>
              <p style="margin-left: auto">日常评审</p>
            </div>
            <div class="row bottom">
              <p class="Use">使用企业数量：{{ item.userCount }} 家</p>
              <p class="Use">创建日期：{{ moment(item.createTime).format('YYYY.MM.DD') }}</p>
            </div>
          </div>
          <div class="right">
            <span>详情</span>
            <span @click="handleAddPager(item)">编辑</span>
            <span @click="httpDeleteIndustry(item.id)">删除</span>
          </div>
        </div>
      </template>
      <template v-else>
        <div style="text-align: center">
          <img src="../../assets/img/emptyData.png" alt="" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'testPaperIndex',
  components: {},
  data() {
    return {
      testPapeList: [],
      parame: { keyWords: '', limit: 10, page: 1 },
    };
  },
  watch: {},
  created() {
    this.getQuestionList();
  },
  mounted() {},
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
  },
  methods: {
    moment,
    // 获取题库列表
    getQuestionList() {
      this.$axios.post('api/examination/examinationList', this.parame).then((res) => {
        if (res.data.code == 200) {
          const { currPage, list, pageSize, totalCount, totalPage } = res.data.page;
          this.testPapeList = list || [];
          console.log('🚀 ~  this.testPapeList:', this.testPapeList);
        }
      });
    },
    handleAddPager(item) {
      if (item?.userCount) {
        this.$confirm('当前评审细则已分配企业，更改可能会影响自评，请谨慎操作 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$router.push({
              path: '/editTestPaper',
              query: {
                id: item?.id,
              },
            });
          })
          .catch(() => {});
      } else {
        this.$router.push({
          path: '/editTestPaper',
          query: {
            id: item?.id,
          },
        });
      }
    },
    httpDeleteIndustry(id) {
      this.$confirm('此操作将永久删除该评审细则, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$axios.post('api/examination/deleteExamination', { id }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: `删除成功`,
                type: 'success',
                offset: 80,
              });
              this.getQuestionList();
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                offset: 80,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
#testPaperIndex {
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .testPapes {
    margin: 15px 0;
    .boxDiv {
      margin: 12px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 15px;
      border-radius: 6px;
      //   background-color: rgba(1, 112, 242, 0.1);
      background-color: rgba(80, 88, 105, 0.06);
      .left {
        flex: 1;
        margin-right: 15px;
        padding-right: 15px;
        border-right: 1px solid rgba(80, 88, 105, 0.3);
        .row {
          display: flex;
          line-height: 30px;
          align-items: center;
          img {
            margin-right: 8px;
          }
        }
        .bottom,
        .Use {
          color: rgba(80, 88, 105, 0.6);
          font-size: 13px;
          margin-left: auto;
        }
      }
      .right {
        span {
          margin: 0 6px;
          color: rgba(1, 112, 242, 1);
          font-size: 13px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
  #testPaperIndex {
    .testPapes {
      .pcBox {
        display: flex;
      }
      .ipone {
        display: none;
      }
    }
  }
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  #testPaperIndex {
    .testPapes {
      .pcBox {
        display: none;
      }
      .ipone {
        display: flex;
        .left {
          .bottom {
            flex-direction: column;
            align-items: flex-start;
            .Use {
              margin-left: 0;
            }
          }
        }
      }
    }
  }
}
</style>
